<template>
  <div
    class="modal fade"
    id="sys_workflow_arrange_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title" id="myModalLabel">
            流程编排 - {{wf_define.name}}
          </h4>
        </div>

        <!-- modal-body-->
        <div class="modal-body">
          <div class="form-horizontal">

            <div class="form-group">

              <label class="control-sidebar-subheading col-sm-2">
                新增步骤
              </label>
              <label class="control-sidebar-subheading col-sm-1">
                步骤名称:
              </label>

              <label class="control-sidebar-subheading col-sm-3">
                <input
                  id="stepName"
                  name="stepName"
                  type="text"
                  class="form-control field"
                  v-model="form.name"
                />
              </label>

              <label class="control-sidebar-subheading col-sm-1">
                审批人:
              </label>

              <label class="control-sidebar-subheading col-sm-3">
                <select class="form-control" id="newStepApproverSelect" v-model="form.user_id">
                  <option value>请选择执行人</option>
                  <option
                    v-for="(item,index) in employments"
                    :key="index"
                    :value="item.id"
                  >{{item.username}}
                  </option>
                </select>
              </label>

              <label class="col-sm-2">
                <button type="button" class="btn btn-primary" @click="addInStep">增加</button>
              </label>

            </div>


            <div class="arrange-panel">
              <div v-for="(stepItem,index) in inst_define" :key="index" class="arrange-item">
                <!--  信息展示区  -->
                <div class="arrange-info">
                  步骤名称 : {{stepItem.name}}
                  <br/>
                  审批人 : {{stepItem.user_name}}
                </div>
                <!--  操作区  -->
                <div class="arrange-operation">
                  <button class="btn btn-info" type="button" id="sys_move_up" @click="arrange_move_up(index)">上移
                  </button>
                  <br/><br/>
                  <button class="btn btn-info" type="button" id="sys_move_down" @click="arrange_move_down(index)">下移
                  </button>
                </div>
                <!--  移除按钮  -->
                <div class="arrange-remove">
                  <button class="btn btn-warning" type="button" id="sys_remove" @click="arrange_remove(index)">移除
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- modal-footer -->
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn btn-primary" @click="submitArrange">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        wf_define: {}, // 工作流定义
        inst_define: [], // 步骤定义
        employments: [], // 本公司雇员
        form: {} // 新步骤
      }
    },

    props: [],

    mounted: function () {
      var self = this
    },

    methods: {
      initFunc: function (wf_define) {
        console.log('___initFunc 传入 wf_define', wf_define)

        var self = this
        self.wf_define = wf_define
        let org_id = JSON.parse(localStorage.getItem('companyInfo')).id
        self.org_id = org_id

        // 获取本公司该工作流审批设置
        self.global.axiosGet(
          self,
          `workflow_arrange/${org_id}/${wf_define.id}/`,
          function (res) {
            console.log('返回审批步骤定义', res)
            self.inst_define = res.steps || []
          },
          function () {
            alert('审批步骤定义获取失败')
          }
        )

        // 获取本公司雇员
        self.global.axiosGet(
          self,
          `organizations/${org_id}/employments/`,
          function (res) {
            console.log('获取组织下成员列表', res)
            self.employments = res
          }
        )

        $('#sys_workflow_arrange_modal').modal('show') // 展示 modal 框
      },
      arrange_move_up: function (index) {
        let inst_define = JSON.parse(JSON.stringify(this.inst_define));
        if (index === 0)
          return
        inst_define[index] = inst_define.splice(index - 1, 1, inst_define[index])[0];
        this.$set(this, 'inst_define', inst_define);
      },
      arrange_move_down: function (index) {
        let inst_define = JSON.parse(JSON.stringify(this.inst_define));
        if (index === inst_define.length - 1)
          return
        inst_define[index] = inst_define.splice(index + 1, 1, inst_define[index])[0];
        this.$set(this, 'inst_define', inst_define);
      },
      arrange_remove: function (index) {
        let inst_define = JSON.parse(JSON.stringify(this.inst_define));
        inst_define.splice(index, 1);
        this.$set(this, 'inst_define', inst_define);
      },
      addInStep: function () { // 添加步骤
        console.log('___添加步骤', this.form)
        if (!this.form.name || !this.form.user_id) {
          alert('请将信息填写完成')
          return
        }
        let user_name = $('#newStepApproverSelect').find("option:selected").text()
        let inst_define = JSON.parse(JSON.stringify(this.inst_define));
        inst_define.push({
          name: this.form.name,
          user_id: this.form.user_id,
          user_name: user_name
        })
        this.$set(this, 'inst_define', inst_define);
      },
      submitArrange: function () { // 审批通过
        console.log('___调整后的步骤', this.inst_define)
        let self = this
        self.global.axiosPut(
          self,
          `workflow_arrange/${this.org_id}/${this.wf_define.id}/`,
          this.inst_define,
          function (res) {
            alert('提交成功')
          },
          function () {
            alert('提交失败')
          }
        )
      },

    }
  }
</script>

<style scoped>
  .form-fields-panel {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .arrange-panel {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .arrange-item {
    width: 60%;
    height: 100px;
    margin: 10px auto 0 auto;
    border-radius: 10px;
    background-color: #C4C4C4;
    display: flex;
  }

  .arrange-info {
    width: 50%;
    font-size: 18px;
    text-align: center;
    padding: 10px 0 0 0;
  }

  .arrange-operation {
    width: 30%;
    padding: 5px 0 0 0;
  }

  .arrange-remove {
    width: 20%;
    padding: 5px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/workflowArrange.vue